module.exports = __webpack_public_path__ + "img/shijiaoji.aa09a3dc.jpg";